const firstError = (value) => (Array.isArray(value) ? value[0] : value);

export function mapRegisterErrorsI18n(data, t) {
  if (!data || typeof data !== "object") {
    return { form: t("auth.registerFailed") };
  }

  const fieldErrors = {};

  if (data.email) fieldErrors.email = firstError(data.email);
  if (data.full_name) fieldErrors.fullName = firstError(data.full_name);
  if (data.password) fieldErrors.password = firstError(data.password);
  if (data.password2) fieldErrors.password = firstError(data.password2);

  if (data.company) {
    if (typeof data.company === "string") {
      fieldErrors.form = data.company;
    } else {
      if (data.company.company_name) {
        fieldErrors.companyName = firstError(data.company.company_name);
      }
      if (data.company.company_email) {
        fieldErrors.businessEmail = firstError(data.company.company_email);
      }
      if (data.company.address) {
        fieldErrors.businessAddress = firstError(data.company.address);
      }
      if (data.company.ceo) fieldErrors.industry = firstError(data.company.ceo);
    }
  }

  if (data.detail) fieldErrors.form = firstError(data.detail);
  if (data.non_field_errors) fieldErrors.form = firstError(data.non_field_errors);

  if (!fieldErrors.form && Object.keys(fieldErrors).length === 0) {
    fieldErrors.form = t("auth.registerCheckDetails");
  }

  return fieldErrors;
}

export function validateRegisterStepOneI18n(formData, t) {
  const errors = {};

  if (!formData.fullName.trim()) {
    errors.fullName = t("auth.fullNameRequired");
  }

  if (!formData.email.trim()) {
    errors.email = t("auth.emailRequired");
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = t("auth.emailInvalid");
  }

  if (!formData.password) {
    errors.password = t("auth.passwordRequired");
  } else if (formData.password.length < 8) {
    errors.password = t("auth.passwordMinLength");
  }

  return errors;
}

export function validateRegisterStepTwoI18n(formData, t) {
  const errors = {};

  if (!formData.companyName.trim()) {
    errors.companyName = t("auth.companyNameRequired");
  }

  if (!formData.businessEmail.trim()) {
    errors.businessEmail = t("auth.businessEmailRequired");
  } else if (!/\S+@\S+\.\S+/.test(formData.businessEmail)) {
    errors.businessEmail = t("auth.emailInvalid");
  }

  if (!formData.businessAddress.trim()) {
    errors.businessAddress = t("auth.businessAddressRequired");
  }

  if (!formData.industry.trim()) {
    errors.industry = t("auth.industryRequired");
  }

  return errors;
}
